<template>
    <div id="pep_result">
        <div v-if="this.name">
            <h1>{{this.name}} protein info page</h1>
            <b-row>
                <b-col cols="8">
                    <div>
                        <h3 id="summary">Summary</h3>
                        <h4>Entry summary</h4>
                        <p>Transcript id:
                            <router-link :to="{path: `/contig/${this.transcript_id}`}">
                                {{this.transcript_name}}
                            </router-link>
                        </p>
                        <p>Description: {{desc_visible}}</p>
                        <p>cDNA Length: {{cdna_length}}</p>
                        <p>Protein Length: {{protein_length}}</p>
                        <p>CDS annotation: {{cds_annotation}}</p>

                        <h4>Annotation summary</h4>
                        <p>KEGG Orthology: <AnchoredLinks
                                :array="kegg"
                                part_url="http://www.genome.jp/dbget-bin/www_bget?"/></p>
                        <p>Gene Ontology: <AnchoredLinks
                                :array="go"
                                part_url="https://www.ebi.ac.uk/QuickGO/term/"
                        /></p>
                        <p>InterPro: <AnchoredLinks
                                :array="interpro"
                                part_url="http://www.ebi.ac.uk/interpro/entry/"/></p>

                        <h3 id="ann">Annotations</h3>
                        <h4>InterPro</h4>

                        <b-card class="bio_card">{{interpro_tsv_view}}</b-card>

                        <h4>Transdecoder</h4>
                        <TreeInfo :nodes="transdecoder"/>
                        <h3 id="seq">Sequences</h3>
                        <h4>Protein</h4>
                        <b-card class="bio_card">{{protein}}</b-card>
                        <h4>CDNA</h4>
                        <b-card class="bio_card">{{cdna}}</b-card>

                    </div>
                </b-col>
                <b-col cols="4">
                    <b-navbar v-b-scrollspy style="position: fixed;">
                        <b-nav pills vertical>
                            <b-nav-item href="#summary">Summary</b-nav-item>
                            <b-nav-item href="#ann">Annotations</b-nav-item>
                            <b-nav-item href="#seq">Sequences</b-nav-item>
                        </b-nav>
                    </b-navbar>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import AnchoredLinks from "../components/AnchoredLinks";
    import TreeInfo from "../components/TreeInfo";

    export default {
        name: "PepResult",
        data: function () {
            return {
                name: undefined,
                transcript_name: undefined,
                transcript_id: undefined,
                description: undefined,
                cdna_length: undefined,
                protein_length: undefined,
                cds_annotation: undefined,
                kegg_tmp: ['K14572', 'K14574'],
                kegg: undefined,
                go: undefined,
                interpro: undefined,
                interpro_tsv: undefined,
                transdecoder: undefined,
                protein: undefined,
                cdna: undefined
            }
        },
        components: {
            TreeInfo,
            AnchoredLinks
        },
        computed: {
            desc_visible: function () {
                return this.description
            },
            interpro_tsv_view: function () {
                return this.interpro_tsv.map(record => record.join('\t')).join('\n');
            }

        },
        mounted() {
            axios.get(`/get/pep/${this.$route.params.id}`)
                .then(response => {
                    this.name = response.data['short_name'];
                    this.transcript_name = response.data['transcript_name'];
                    this.transcript_id = response.data['transcript_id'];
                    this.description = response.data['description'];
                    this.cds_annotation = response.data['cds_annotation'];
                    this.protein_length = response.data['protein_length'];
                    this.cdna_length = response.data['cdna_length'];
                    this.kegg = response.data['kegg'];
                    this.go = response.data['go'];
                    this.interpro = response.data['interpro'];
                    this.interpro_tsv = response.data['interpro_tsv'];
                    this.transdecoder = response.data['transdecoder'];
                    this.protein = response.data['protein'];
                    this.cdna = response.data['cdna'];
                })
        }
    }
</script>

<style scoped lang="scss">
    .bio_card {
        font-family: Courier, monospace;
        white-space: pre;
        font-size: 16px;
        overflow: auto;
    }
</style>